// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"d72fc031","498":"d90d976d","703":"d0f848e5"}[chunkId] + ".chunk.js";
};